/**
 * @desc getAccessConfirmation
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(params: API.auth.authPage.patchConfirm_access.Params, options?: any) {
  return updateResponse(
    http(URL + `/oauth/confirm_access`, {
      method: "PATCH",
      params,

      ...options,
    }),
  );
}
